var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 32,
    viewBox: "0 0 36 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.106 22.5983C28.8033 23.6812 22.7986 28.2741 20.5388 29.7887C18.9463 30.8559 20.9995 15.6814 20.9995 15.6814C24.3334 13.8517 28.3506 7.88489 30.8486 9.59179C31.5247 9.86561 30.9449 12.8561 30.884 13.4727C30.823 14.0893 29.6132 22.1367 29.1059 22.5985L29.106 22.5983Z",
    fill: "url(#paint0_linear_302_812)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.4535 9.17936C31.6336 10.5683 21.8881 16.3603 20.6572 15.7052C15.5072 13.7609 4.54169 9.68889 6.52309 9.13412L17.3936 4.35049C18.5348 4.17342 25.9469 6.96 30.4536 9.17963L30.4535 9.17936Z",
    fill: "url(#paint1_linear_302_812)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6037 29.8204L21.0831 15.8129C21.0831 15.8129 7.13135 9.21728 5.97017 9.56103C4.84864 9.89382 5.8736 22.629 6.65266 23.2947C7.89678 24.3594 19.6034 29.8202 19.6034 29.8202L19.6037 29.8204Z",
    fill: "url(#paint2_linear_302_812)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.05074 22.2125C7.20284 21.2272 7.05224 20.0508 7.71528 19.5859C8.37766 19.1207 9.60222 19.5431 10.4501 20.5284C11.298 21.5138 11.4483 22.6893 10.7859 23.1545C10.1228 23.6194 8.89797 23.1976 8.05074 22.2125Z",
    fill: "url(#paint3_radial_302_812)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04774 15.4322C7.19953 14.4474 7.0496 13.2714 7.71198 12.8061C8.37502 12.3412 9.59989 12.7631 10.4468 13.7487C11.295 14.7334 11.4456 15.9098 10.7826 16.3747C10.1202 16.8399 8.89533 16.4181 8.04774 15.4322Z",
    fill: "url(#paint4_radial_302_812)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3689 17.0651C20.2937 15.8272 21.2589 15.1981 22.039 14.9535L7.99917 8.76347C6.9716 8.91942 5.31734 9.33793 5.70451 10.4715C5.792 10.7275 20.2332 17.0576 20.3689 17.0651Z",
    fill: "url(#paint5_linear_302_812)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5971 14.6317C20.2286 15.3076 21.512 15.7517 22.591 15.153L21.3423 29.2419C20.6431 30.0806 20.301 30.2912 18.2193 29.1871L18.5971 14.6317Z",
    fill: "url(#paint6_linear_302_812)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4381 25.67C22.783 26.5648 21.97 26.9543 21.6223 26.5402C21.2748 26.1254 21.5246 25.0636 22.1801 24.1689C22.8354 23.2734 23.6484 22.8839 23.9959 23.2987C24.3433 23.7134 24.0938 24.7746 23.4381 25.67Z",
    fill: "url(#paint7_radial_302_812)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3583 17.9042C21.9385 19.0777 22.0944 20.0298 22.7064 20.0292C23.318 20.0292 24.1543 19.0767 24.5735 17.9029C24.993 16.7292 24.8375 15.7773 24.2257 15.7772C23.6138 15.7778 22.7778 16.7297 22.3583 17.9042Z",
    fill: "url(#paint8_radial_302_812)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M15.186 25.7113C14.3378 24.7266 14.1872 23.5502 14.8502 23.0853C15.5126 22.62 16.7375 23.0419 17.5844 24.0275C18.4323 25.0128 18.5832 26.1886 17.9202 26.6535C17.2578 27.1188 16.0329 26.6969 15.186 25.7113Z",
    fill: "url(#paint9_radial_302_812)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5259 18.8589C14.678 17.8736 14.5277 16.6981 15.1901 16.2329C15.8532 15.768 17.0774 16.1895 17.9253 17.1748C18.7732 18.1602 18.9231 19.3363 18.2607 19.8015C17.5983 20.2667 16.3738 19.8443 15.5259 18.8589Z",
    fill: "url(#paint10_radial_302_812)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3472 14.4549C20.6741 14.8101 22.0494 15.1221 21.3974 17.2935L31.0805 11.5013C31.5915 9.05741 30.3901 9.22346 28.745 8.70469L19.3473 14.4548L19.3472 14.4549Z",
    fill: "url(#paint11_linear_302_812)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5607 8.49806C24.3414 8.4751 23.4814 8.93266 23.6392 9.51961C23.797 10.1066 24.9135 10.6008 26.1329 10.6234C27.3518 10.6463 28.2123 10.189 28.0543 9.60193C27.8964 9.01488 26.7801 8.52079 25.5607 8.49806Z",
    fill: "url(#paint12_radial_302_812)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9199 17.0723C17.9451 16.6154 17.4987 15.5914 17.9234 14.7851C18.3478 13.9794 19.4826 13.6964 20.4574 14.1532C21.4323 14.6101 21.878 15.6337 21.4536 16.4394C21.0289 17.2458 19.8948 17.5291 18.9199 17.0723Z",
    fill: "url(#paint13_radial_302_812)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2572 19.9093C23.8374 21.0828 23.9933 22.0349 24.6053 22.0344C25.2169 22.0344 26.0531 21.0818 26.4723 19.908C26.8919 18.7344 26.7363 17.7824 26.1246 17.7823C25.5127 17.783 24.6766 18.7348 24.2572 19.9093Z",
    fill: "url(#paint14_radial_302_812)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8932 14.6399C26.5046 15.7012 26.6205 16.5532 27.1521 16.5416C27.6834 16.5305 28.4293 15.66 28.8174 14.5985C29.2058 13.5371 29.0901 12.6852 28.5587 12.6963C28.0272 12.7079 27.2815 13.5778 26.8932 14.6399Z",
    fill: "url(#paint15_radial_302_812)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6198 20.7568C26.2199 21.797 26.2807 22.6129 26.7556 22.5781C27.2302 22.5437 27.9392 21.6715 28.3386 20.6311C28.7383 19.5909 28.6778 18.775 28.2031 18.8093C27.7283 18.8443 27.0194 19.7158 26.6198 20.7568Z",
    fill: "url(#paint16_radial_302_812)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0829 6.90924C19.9552 6.90552 19.1519 7.35251 19.2881 7.90721C19.4243 8.46191 20.4491 8.91436 21.5769 8.91779C22.7043 8.92146 23.508 8.47467 23.3717 7.91988C23.2353 7.3651 22.2107 6.91273 21.0829 6.90924Z",
    fill: "url(#paint17_radial_302_812)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M17.248 5.38695C16.1983 5.3961 15.4449 5.82931 15.5646 6.35417C15.6844 6.87903 16.6326 7.29687 17.6825 7.28745C18.7319 7.27825 19.4858 6.84522 19.3658 6.32028C19.2459 5.79534 18.2978 5.37758 17.248 5.38695Z",
    fill: "url(#paint18_radial_302_812)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1539 7.91607C9.81802 7.92131 8.86211 8.46392 9.01808 9.12752C9.17404 9.79112 10.3836 10.3245 11.7196 10.319C13.0551 10.3136 14.0116 9.77127 13.8554 9.10757C13.6992 8.44387 12.4898 7.91055 11.1539 7.91607Z",
    fill: "url(#paint19_radial_302_812)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6927 9.74314C14.5278 9.74565 13.6951 10.216 13.8323 10.7933C13.9694 11.3706 15.0251 11.8363 16.1902 11.8335C17.3548 11.8309 18.1879 11.3607 18.0505 10.7834C17.9132 10.206 16.8577 9.74039 15.6927 9.74314Z",
    fill: "url(#paint20_radial_302_812)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2394 11.6112C18.9536 11.5215 18.0761 11.9152 18.2788 12.49C18.4816 13.0648 19.6885 13.6032 20.9745 13.6926C22.26 13.7822 23.138 13.3888 22.9351 12.8139C22.7321 12.239 21.5254 11.7006 20.2394 11.6112Z",
    fill: "url(#paint21_radial_302_812)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8806 13.7886L19.8601 15.5258C21.2334 16.7724 21.2315 16.7707 21.2334 16.7724C21.8446 16.3664 22.2161 15.7703 22.1553 15.1688C22.0652 14.2833 21.0705 13.697 19.8806 13.7886Z",
    fill: "url(#paint22_linear_302_812)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.0212 15.5682L17.516 16.2095C17.841 17.0141 18.9568 17.5154 20.1969 17.3595C20.7247 17.2926 21.2007 17.116 21.58 16.8686L20.0212 15.5682Z",
    fill: "url(#paint23_linear_302_812)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7055 13.9384C18.4061 14.1405 17.4305 15.0727 17.5265 16.0203C17.5376 16.1256 17.5615 16.2269 17.5962 16.3233L19.9381 15.6455L19.9974 13.9065C19.9013 13.9131 19.804 13.9237 19.7055 13.9384Z",
    fill: "url(#paint24_linear_302_812)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_302_812",
    x1: 28.5798,
    y1: 18.2759,
    x2: 17.9859,
    y2: 24.7571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECECEC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B5B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_302_812",
    x1: 16.2338,
    y1: 8.38714,
    x2: 28.2823,
    y2: 14.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66072,
    stopColor: "#BFBFBF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBEBEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_302_812",
    x1: 7.52818,
    y1: 17.8879,
    x2: 21.861,
    y2: 18.7166,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8343,
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.88906 22.056) rotate(134.145) scale(0.618465 1.35669)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.92378 15.2054) rotate(135.503) scale(0.54942 1.19798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_302_812",
    x1: 14.2193,
    y1: 11.7899,
    x2: 13.3707,
    y2: 13.5641,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_302_812",
    x1: 18.4685,
    y1: 21.7323,
    x2: 21.343,
    y2: 21.9446,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#808080"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59794,
    stopColor: "#D0D0D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78732,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECECE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.0555 25.6436) rotate(3.10762) scale(0.617852 0.870235)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.0197 18.7508) rotate(-178.03) scale(0.627112 0.823277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.4368 25.7687) rotate(30.4033) scale(1.45957 0.696561)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.7752 18.9208) rotate(124.263) scale(0.552951 1.29501)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_302_812",
    x1: 23.2485,
    y1: 11.4114,
    x2: 26.5599,
    y2: 14.4048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E7E7E7"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.2288 9.27128) rotate(82.3793) scale(0.511081 1.00662)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.6879 15.6126) rotate(44.2048) scale(3.24389 3.9294)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46082,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9186 20.756) rotate(-178.03) scale(0.627112 0.823277)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.4504 15.3881) rotate(-179.162) scale(0.544022 0.739785)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(27.0795 21.453) rotate(178.045) scale(0.485214 0.711396)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.763 7.64797) rotate(83.5463) scale(0.482803 0.935371)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.9408 6.09157) rotate(84.4156) scale(0.456819 0.873155)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.7677 8.80414) rotate(84.0724) scale(0.577564 1.10999)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.3575 10.5148) rotate(83.9445) scale(0.502441 0.96754)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_302_812",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9379 12.3385) rotate(78.1901) scale(0.502944 1.03571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_302_812",
    x1: 21.6578,
    y1: 14.2997,
    x2: 21.4971,
    y2: 16.4822,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42018,
    stopColor: "#BDBDBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55212,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C8C8C8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_302_812",
    x1: 20.9043,
    y1: 16.5721,
    x2: 18.9264,
    y2: 16.2505,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46082,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_302_812",
    x1: 19.9525,
    y1: 13.5007,
    x2: 18.3877,
    y2: 15.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57332,
    stopColor: "#B4B4B4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#808080"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice);
export default __webpack_public_path__ + "static/media/dice.479cc2ecb11fec9e9b5ababb4973f3ea.svg";
export { ForwardRef as ReactComponent };